export default "__VITE_ASSET__moJFpKDL__"